import * as React from "react";
import { ItemKeyHelper } from "components/utility/ItemKeyHelper";
import LinksGridItem from "components/flexComponents/Links/GridView/LinksGridItem";
import { withStores } from "stores";
import { LinksGridWithDialogProps, Tab } from "components/flexComponents/TabGroup/typings";
import { LinkDialog } from "components/flexComponents/Links/GridView/LinkDialog";
import { UitkLayoutGrid } from "uitk-react-layout-grid";
import { UitkCard, UitkCardContent } from "uitk-react-cards";
import { QueryRoute, RouteStore } from "bernie-core";
import { ExtendedContextStore } from "typings/flexFramework/FlexDefinitions";
import { Viewport, ViewSmall, ViewMedium, ViewLarge, Layer } from "bernie-view";
import { observer } from "mobx-react";

const LinksGridWithDialog = withStores("routeStore")(
  observer((props: LinksGridWithDialogProps) => {
    const { routeStore, groups, view, id, context } = props;

    const keyHelper = new ItemKeyHelper("LinksGroup");
    const dialogId: string = `linksDialog-${id}`;

    const onDismiss = () => {
      routeStore.goBack();
    };

    return (
      <Viewport>
        <ViewSmall>
          <LinksGridWithDialogDom
            routeStore={routeStore}
            groups={groups}
            view={view}
            id={id}
            context={context}
            columns={1}
            keyHelper={keyHelper}
            dialogId={dialogId}
            onDismiss={onDismiss}
          />
        </ViewSmall>
        <ViewMedium>
          <LinksGridWithDialogDom
            routeStore={routeStore}
            groups={groups}
            view={view}
            id={id}
            context={context}
            columns={groups.length === 1 ? 1 : 2}
            keyHelper={keyHelper}
            dialogId={dialogId}
            onDismiss={onDismiss}
          />
        </ViewMedium>
        <ViewLarge>
          <LinksGridWithDialogDom
            routeStore={routeStore}
            groups={groups}
            view={view}
            id={id}
            context={context}
            columns={groups.length === 1 ? 1 : 3}
            keyHelper={keyHelper}
            dialogId={dialogId}
            onDismiss={onDismiss}
          />
        </ViewLarge>
      </Viewport>
    );
  })
);

interface LinksGridWithDialogDomProps {
  routeStore: RouteStore;
  groups: Tab[];
  view: string;
  id: string;
  context: ExtendedContextStore;
  columns: any;
  keyHelper: ItemKeyHelper;
  dialogId: string;
  onDismiss: () => void;
}

const LinksGridWithDialogDom = ({
  routeStore,
  groups,
  view,
  id,
  context,
  columns,
  keyHelper,
  dialogId,
  onDismiss,
}: LinksGridWithDialogDomProps) => {
  const linksCardView = view === "standard-link" && groups.length === 1 ? "" : "all-x-padding-two";

  return (
    <div className="LinksGridWithDialog uitk-cell all-cell-1-1">
      <UitkCard>
        <UitkCardContent>
          <div className="uitk-cell">
            <UitkLayoutGrid space="one" className={linksCardView} columns={columns}>
              {groups.map((group) => (
                <LinksGridItem
                  key={keyHelper.next()}
                  view={view}
                  group={group}
                  routeStore={routeStore}
                  id={id}
                  context={context}
                />
              ))}
              <QueryRoute query={{ pwaDialog: dialogId }}>
                <Layer id={dialogId} onDismiss={onDismiss}>
                  <LinkDialog key={keyHelper.next()} id={id} onDismiss={onDismiss} />
                </Layer>
              </QueryRoute>
            </UitkLayoutGrid>
          </div>
        </UitkCardContent>
      </UitkCard>
    </div>
  );
};

export default LinksGridWithDialog;
